import React from 'react'
import SinglePropertyView from '../Components/Property/SinglePropertyView'

const SinglePropertyViewPage = () => {
  return (
    <SinglePropertyView />
  )
}

export default SinglePropertyViewPage